export default "__VITE_ASSET__DXQTKiTD__"